"use client";
import { Button } from "@/components/ui/button";
import KpiCard from "@/components/dashboard/KpiCard";
import { Progress } from "@/components/ui/progress";
import { Mail, Globe, Cloud, Users, Download } from "lucide-react";
import { useTranslation } from "react-i18next";

const StorageAnalytics = () => {
  const { t } = useTranslation();

  const usedStorage = 2400; // GB
  const totalStorage = 5000; // GB
  const usagePercent = (usedStorage / totalStorage) * 100;

  const storageCards = [
    { title: "Exchange", value: "840 GB", icon: Mail, subtitle: `352 ${String(t("storageAnalytics.mailboxes"))}` },
    { title: "SharePoint", value: "720 GB", icon: Globe, subtitle: `18 ${String(t("storageAnalytics.siteCollections"))}` },
    { title: "OneDrive", value: "600 GB", icon: Cloud, subtitle: `124 ${String(t("storageAnalytics.users"))}` },
    { title: "Teams", value: "240 GB", icon: Users, subtitle: `32 ${String(t("storageAnalytics.teams"))}` },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{String(t("storageAnalytics.title"))}</h1>
        <p className="text-sm text-muted-foreground mt-1">{String(t("storageAnalytics.subtitle"))}</p>
      </div>

      <div className="rounded-lg border border-border/50 bg-card p-5 shadow-sm">
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-medium">{String(t("storageAnalytics.storageUsage"))}</h3>
          <span className="text-sm text-muted-foreground">
            {(usedStorage / 1000).toFixed(1)} TB / {(totalStorage / 1000).toFixed(1)} TB
          </span>
        </div>
        <Progress value={usagePercent} className="h-3" />
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-muted-foreground">{usagePercent.toFixed(0)}% {String(t("storageAnalytics.used"))}</span>
          <span className="text-xs text-muted-foreground">{((totalStorage - usedStorage) / 1000).toFixed(1)} TB {String(t("storageAnalytics.available"))}</span>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {storageCards.map((c) => (
          <KpiCard key={c.title} {...c} />
        ))}
      </div>

      {/* <div className="rounded-lg border border-border/50 bg-card p-5 shadow-sm">
        <h3 className="text-sm font-medium mb-4">{String(t("storageAnalytics.costForecast"))}</h3>
        ...
      </div> */}
    </div>
  );
};

export default StorageAnalytics;
